"use client";

import { Link } from "@/components/common/Link";
const transactionAreas = [{
  number: "01",
  eyebrow: "Purchase & Sale",
  title: "Contracts, Purchase Agreements & Closings",
  description: "Comprehensive preparation, review, and negotiation of purchase and sale agreements, closing documents, contingencies, representations, payment terms, and transaction provisions designed to ensure documents precisely reflect the parties' agreements."
}, {
  number: "02",
  eyebrow: "Lease & Rights",
  title: "Commercial & Residential Leasing",
  description: "Detailed drafting and review of commercial and residential lease agreements, paying close attention to landlord and tenant obligations, payment structures, use restrictions, renewal rights, and ongoing relationship terms."
}, {
  number: "03",
  eyebrow: "Title & Finance",
  title: "Title Matters, Liens & Encumbrances",
  description: "Thorough evaluation of title commitments, liens, encumbrances, property records, and related transactional issues to secure clear ownership rights and allow the transaction to proceed smoothly toward completion."
}];
export default function ContractsAndTransitions() {
  return <section id="contractsandtransitions" className="bg-[hsl(30,10%,95%)] py-20 text-foreground md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="max-w-3xl">
          <p className="mb-6 font-default text-xs uppercase tracking-[0.25em]" style={{
          color: "var(--secondary)"
        }}>
            Contracts &amp; Real Estate Transactions
          </p>

          <h2 className="font-default text-4xl font-light leading-[1.05] tracking-tight text-foreground md:text-5xl lg:text-[3rem]" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Contracts, Closings &amp; Real Estate Transactions
          </h2>

          <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>
            A real estate transaction is defined by more than the closing
            itself. Purchase agreements, leases, title matters, payment
            obligations, disclosures, and related documents determine the
            parties&apos; rights long before and after a transaction is
            completed.
          </p>

          <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>The office approaches these matters through careful review of the governing documents and the practical consequences of the terms being negotiated.</p>
        </div>

        {}
        <div className="mt-16 max-w-6xl border-t md:mt-20" style={{
        borderColor: "var(--border)"
      }}>
          {transactionAreas.map((item, index) => <div key={item.number} data-index={index} className={`grid gap-7 border-b py-10 md:grid-cols-[110px_1fr_1.35fr] md:items-start md:gap-10 md:py-12 ${index === 0 ? "bg-white/80 px-6 shadow-sm rounded-lg my-4 md:px-8 md:py-14 border border-[var(--border)]" : ""}`} style={{
          borderColor: index === 0 ? "var(--border)" : "var(--border)"
        }}>
              {}
              <div>
                <span className="font-default text-xs uppercase tracking-[0.22em]" style={{
              color: "var(--secondary)"
            }}>
                  {item.number}
                </span>

                <div aria-hidden="true" className="mt-5 h-px w-10" style={{
              backgroundColor: "var(--secondary)",
              opacity: 0.5
            }} />
              </div>

              {}
              <div>
                <p className="font-default text-[0.7rem] uppercase tracking-[0.22em]" style={{
              color: "var(--secondary)"
            }}>
                  {item.eyebrow}
                </p>

                <h3 className="mt-3 font-default text-2xl font-light leading-tight text-foreground md:text-3xl" style={{
              fontFamily: "var(--font-serif)"
            }}>
                  {item.title}
                </h3>
              </div>

              {}
              <div>
                <p className="font-default text-base leading-relaxed md:text-lg" style={{
              color: "var(--muted-foreground)"
            }}>
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-16 max-w-3xl border-t pt-12 md:mt-20 md:pt-16" style={{
        borderColor: "var(--border)"
      }}>
          <p className="mb-4 font-default text-xs uppercase tracking-[0.25em]" style={{
          color: "var(--secondary)"
        }}>
            The Next Step
          </p>

          <h3 className="font-default text-3xl font-light leading-tight text-foreground md:text-4xl" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Discuss Your Real Estate Matter
          </h3>

          <p className="mt-5 max-w-2xl font-default text-base leading-relaxed md:text-lg" style={{
          color: "var(--muted-foreground)"
        }}>
            Whether the matter involves a purchase, sale, lease, title issue,
            closing document, or another real estate concern, the first step is
            to identify the governing documents, the relevant facts, and the
            transaction terms requiring attention.
          </p>

          <div className="mt-8">
            <Link to="/ContactUsPage" className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 font-default text-sm font-medium text-primary-foreground no-underline transition-opacity hover:opacity-90">
              Request a Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>;
}